/**
 * Which attachment options the composer offers. A message carries one attachment.
 * Text goes with a photo or a clip, and not with a voice message.
 *
 * @param {{hasText: boolean, hasPhoto: boolean, hasVideo: boolean}} composer
 * @returns {{camera: boolean, mic: boolean, video: boolean}} true shows the option
 */
export function attachmentOptions({ hasText, hasPhoto, hasVideo }) {
  return {
    camera: !hasVideo && (hasPhoto || !hasText),
    mic: !hasText && !hasVideo,
    video: !hasText && !hasPhoto && !hasVideo,
  };
}
